import styled from 'styled-components/macro';
import { colors, Input } from '@twnel/web-components';

const DEFAULT_PADDING = 16;
const ICON_SIZE = 8;
const LEVEL_SPACE = 16;

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  z-index: 10;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  width: 359px;
  height: 246px;
  border-radius: 5px;
  display: flex;
  border: 1px solid #${colors.gray};
  background: #${colors.white};
  div, input {
    outline: none !important;
    width: 100%;
  }
`;

export const Bar = styled.div`
  position: absolute;
  height: 2rem;
  top: 100%;
  right: 0;
  background: #${colors.darkGray};
  border-radius: 4px;
  display: ${(props) => (props.displayItem ? 'flex' : 'none')};
  box-sizing: border-box;
  overflow: hidden;
  z-index: 10;
`;

export const ItemWrapper = styled.li`
  padding: .75rem 1.25rem;
  padding-left: ${(props) => DEFAULT_PADDING + ICON_SIZE + props.level * LEVEL_SPACE}px;
  cursor: pointer;
  z-index: ${(props) => (props.focused ? 999 : 'unset')};
  margin-top: 0;
  position: relative;
  border-bottom: 1px solid #${colors.gray};
  color: #${colors.textBlack};
  &:hover {
    background: #${colors.darkGray};
  }
`;

export const Chevron = styled.div`
  display:flex;
  width: auto !important;
  margin-right: 8px;
  font-size: 0.8rem;
  transition: transform 0.6s ease;

  &.rotate {
    transform: rotate(90deg);
  }
`;

export const TreeWrapper = styled.div`
  overflow-y: auto;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
`;

export const TestDiv = styled.div`
  display: inline-block;
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  overflow-y: auto;
`;
